import type { Step } from '@/components/wizard/Step';

import type { AddConnectorWizardState } from './addConnectorWizardState';
import { AddConnectorStep } from './steps/AddConnectorStep';
import { AddGcpConnectorStep } from './steps/AddGcpConnectorStep';
import { ConnectorTypeStep } from './steps/ConnectorTypeStep';

export const AddConnectorCreationFlow: Step<AddConnectorWizardState> = {
  id: 'select_connector_type',
  Component: ConnectorTypeStep,
  next: [
    // next[0]: AWS Account
    {
      id: 'add_aws_connector',
      Component: AddConnectorStep,
    },
    // next[1]: GCP Project
    {
      id: 'add_gcp_connector',
      Component: AddGcpConnectorStep,
    },
  ],
};
